module.exports = __webpack_public_path__ + "cd-icon-small-arrow.200ede21437c138430bb.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/assets/images/cd-icon-small-arrow.svg
// module id = ../../../../../src/assets/images/cd-icon-small-arrow.svg
// module chunks = styles